import Axios from "./Axios";

export default class SettingsService extends Axios {
  getByKey(key) {
    return this.axios.get(`/settings/${key}`);
  }

  getAccessPointURL(pdv, number){
    return this.axios.get(`/access-point/pdv/${pdv}/table/${number}/url`)
  }
}
